unit LoadTypes;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, XData.Web.Client, Data.DB,
  WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter,
  VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.Buttons, VCL.TMSFNCBitmapContainer;

type
  TfrmLoadTypes = class(TForm)
    WebPanel1: TPanel;
    pnlHead: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebButton2: TButton;
    dgLoadTypes: TTMSFNCDataGrid;
    dgdbaLoadTypes: TTMSFNCDataGridDatabaseAdapter;
    wdsLoadTypes: TXDataWebDataSet;
    dsLoadTypes: TDataSource;
    wcLoadTypes: TXDataWebClient;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    edtLoadTypesPC: TEdit;
    wdsLoadTypesLoadType: TStringField;
    WebPanel4: TPanel;
    WebSpeedButton5: TSpeedButton;
    WebSpeedButton6: TSpeedButton;
    WebSpeedButton7: TSpeedButton;
    WebSpeedButton8: TSpeedButton;
    btnInsert: TSpeedButton;
    TMSFNCBitmapContainer1: TTMSFNCBitmapContainer;
    procedure WebFormShow(Sender: TObject);
    procedure dgLoadTypesCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure btnInsertClick(Sender: TObject);
    procedure dgLoadTypesGetCellLayout(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
  private
    { Private declarations }
    iLoadTypesMaxPC, iLoadTypesPC : Integer;

    procedure PopulateLoadTypes;
  public
    { Public declarations }
    sLoadtype : String;
  protected procedure LoadDFMValues; override; end;

var
  frmLoadTypes: TfrmLoadTypes;

implementation

{$R *.dfm}
uses
  stfmssystem.connection, share.common;

procedure TfrmLoadTypes.dgLoadTypesCellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  if AColumn = 0 then
    Begin
      dgdbaLoadTypes.SetActiveRecord(ARow);
      sLoadtype := dgdbaLoadTypes.FieldAtColumn[0].AsString;
    End;
end;

procedure TfrmLoadTypes.dgLoadTypesGetCellLayout(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dgdbaLoadTypes.IsValidDataCell(ACell.Coordinate) then
    begin
      if ACell.Column = 1 then
        ACell.AsBitmapCell.BitmapName := TMSFNCBitmapContainer1.BitmapNames[1];

      if ACell.Column = 2 then
        ACell.AsBitmapCell.BitmapName := TMSFNCBitmapContainer1.BitmapNames[0];
    end;
end;

procedure TfrmLoadTypes.PopulateLoadTypes;
var
  sJsonParam : String;
  procedure OnError(Error: TXDataClientError);
    begin
      PopulateLoadTypes
    end;

  procedure OnResult(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          PopulateLoadTypes
        end
      else
        begin
          wdsLoadTypes.Close;
          wdsLoadTypes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsLoadTypes.Open;
        end;
    end;

  procedure OnResultPC(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          PopulateLoadTypes
        end
      else
        begin
          iLoadTypesMaxPC := Integer(TJSObject(Response.Result)['value']);

          edtLoadTypesPC.Text := IntToStr(iLoadTypesPC) + ' of ' + IntToStr(iLoadTypesMaxPC);

          sJsonParam := '{"Pagecount":' + IntToStr(iLoadTypesPC) + '}';

          wcLoadTypes.RawInvoke('IstfmsloadsService.Get_LoadTypes_View',[sJsonParam],@OnResult,@OnError)
        end;
    end;

begin
  wcLoadTypes.RawInvoke('IstfmsloadsService.Get_LoadTypes_MaxPC',[],@OnResultPC,@OnError);
end;

procedure TfrmLoadTypes.WebButton1Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmLoadTypes.WebButton2Click(Sender: TObject);
begin
  sLoadtype := '';
  Close;
end;

procedure TfrmLoadTypes.WebFormShow(Sender: TObject);
begin
  iLoadTypesPC := 1;
  PopulateLoadTypes;
end;

procedure TfrmLoadTypes.btnInsertClick(Sender: TObject);
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('Load Type Successfully Saved');
      btnInsert.Enabled := true;
      PopulateLoadTypes
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
      btnInsert.Enabled := true;
    end;
begin
  btnInsert.Enabled := false;
  wdsLoadTypes.Insert;
  wdsLoadTypes.FieldByName('LoadType').AsString := InputBox('Load Type','Enter Load Type:','');

  wcLoadTypes.RawInvoke('IstfmsloadsService.Put_LoadTypes_Insert',[GetJsonFromDataSet(wdsLoadTypes)],@OnSuccess,@OnError);
end;

procedure TfrmLoadTypes.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  pnlHead := TPanel.Create(Self);
  TMSFNCBitmapContainer1 := TTMSFNCBitmapContainer.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  edtLoadTypesPC := TEdit.Create(Self);
  dgLoadTypes := TTMSFNCDataGrid.Create(Self);
  dgdbaLoadTypes := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  btnInsert := TSpeedButton.Create(Self);
  wdsLoadTypes := TXDataWebDataSet.Create(Self);
  wdsLoadTypesLoadType := TStringField.Create(Self);
  dsLoadTypes := TDataSource.Create(Self);
  wcLoadTypes := TXDataWebClient.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  pnlHead.BeforeLoadDFMValues;
  TMSFNCBitmapContainer1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  edtLoadTypesPC.BeforeLoadDFMValues;
  dgLoadTypes.BeforeLoadDFMValues;
  dgdbaLoadTypes.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  btnInsert.BeforeLoadDFMValues;
  wdsLoadTypes.BeforeLoadDFMValues;
  wdsLoadTypesLoadType.BeforeLoadDFMValues;
  dsLoadTypes.BeforeLoadDFMValues;
  wcLoadTypes.BeforeLoadDFMValues;
  try
    Name := 'frmLoadTypes';
    Width := 460;
    Height := 480;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 460;
    WebPanel1.Height := 480;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    pnlHead.SetParentComponent(WebPanel1);
    pnlHead.Name := 'pnlHead';
    pnlHead.Left := 0;
    pnlHead.Top := 0;
    pnlHead.Width := 460;
    pnlHead.Height := 60;
    pnlHead.Align := alTop;
    pnlHead.Caption := 'Load Types';
    pnlHead.Color := clSilver;
    pnlHead.Font.Charset := DEFAULT_CHARSET;
    pnlHead.Font.Color := clWindowText;
    pnlHead.Font.Height := -16;
    pnlHead.Font.Name := 'Segoe UI';
    pnlHead.Font.Style := [fsBold];
    pnlHead.ParentFont := False;
    pnlHead.TabOrder := 0;
    TMSFNCBitmapContainer1.SetParentComponent(pnlHead);
    TMSFNCBitmapContainer1.Name := 'TMSFNCBitmapContainer1';
    TMSFNCBitmapContainer1.Left := 376;
    TMSFNCBitmapContainer1.Top := 8;
    TMSFNCBitmapContainer1.Width := 26;
    TMSFNCBitmapContainer1.Height := 26;
    TMSFNCBitmapContainer1.Visible := True;
    TMSFNCBitmapContainer1.Items.Clear;
    with TMSFNCBitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('LoadTypes.TMSFNCBitmapContainer1.Items.Bitmap.svg');
      Name := 'delete.svg';
      Tag := 0;
    end;
    with TMSFNCBitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('LoadTypes.TMSFNCBitmapContainer1.Items.Bitmap_1.svg');
      Name := 'edit.svg';
      Tag := 0;
    end;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 387;
    WebPanel3.Width := 460;
    WebPanel3.Height := 93;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 19;
    WebButton1.Top := 48;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Select';
    WebButton1.Color := clGreenyellow;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 139;
    WebButton2.Top := 48;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Close';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebSpeedButton1.SetParentComponent(WebPanel3);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 261;
    WebSpeedButton1.Top := 49;
    WebSpeedButton1.Width := 24;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 2;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    WebSpeedButton2.SetParentComponent(WebPanel3);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 291;
    WebSpeedButton2.Top := 49;
    WebSpeedButton2.Width := 24;
    WebSpeedButton2.Height := 24;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 3;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    WebSpeedButton3.SetParentComponent(WebPanel3);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 385;
    WebSpeedButton3.Top := 50;
    WebSpeedButton3.Width := 24;
    WebSpeedButton3.Height := 24;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 4;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    WebSpeedButton4.SetParentComponent(WebPanel3);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 415;
    WebSpeedButton4.Top := 50;
    WebSpeedButton4.Width := 24;
    WebSpeedButton4.Height := 24;
    WebSpeedButton4.Caption := '>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 5;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    edtLoadTypesPC.SetParentComponent(WebPanel3);
    edtLoadTypesPC.Name := 'edtLoadTypesPC';
    edtLoadTypesPC.Left := 321;
    edtLoadTypesPC.Top := 49;
    edtLoadTypesPC.Width := 58;
    edtLoadTypesPC.Height := 25;
    edtLoadTypesPC.ChildOrder := 6;
    edtLoadTypesPC.HeightPercent := 100.000000000000000000;
    edtLoadTypesPC.Text := '0 of 0';
    edtLoadTypesPC.WidthPercent := 100.000000000000000000;
    dgLoadTypes.SetParentComponent(WebPanel1);
    dgLoadTypes.Name := 'dgLoadTypes';
    dgLoadTypes.Left := 0;
    dgLoadTypes.Top := 120;
    dgLoadTypes.Width := 460;
    dgLoadTypes.Height := 267;
    dgLoadTypes.Align := alClient;
    dgLoadTypes.ParentDoubleBuffered := False;
    dgLoadTypes.DoubleBuffered := True;
    dgLoadTypes.TabOrder := 2;
    dgLoadTypes.ShowAcceleratorChar := False;
    dgLoadTypes.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgLoadTypes.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgLoadTypes.Header.VisualGrouping.Layout.Font.Height := -12;
    dgLoadTypes.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgLoadTypes.Header.VisualGrouping.Layout.Font.Style := [];
    dgLoadTypes.Adapter := dgdbaLoadTypes;
    dgLoadTypes.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgLoadTypes.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgLoadTypes.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgLoadTypes.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgLoadTypes.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgLoadTypes.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgLoadTypes.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgLoadTypes.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgLoadTypes.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgLoadTypes.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgLoadTypes.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgLoadTypes.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgLoadTypes.CellAppearance.BandLayout.Font.Height := -12;
    dgLoadTypes.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgLoadTypes.CellAppearance.BandLayout.Font.Style := [];
    dgLoadTypes.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgLoadTypes.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgLoadTypes.CellAppearance.FixedLayout.Font.Height := -12;
    dgLoadTypes.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgLoadTypes.CellAppearance.FixedLayout.Font.Style := [];
    dgLoadTypes.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgLoadTypes.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgLoadTypes.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgLoadTypes.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgLoadTypes.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgLoadTypes.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgLoadTypes.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgLoadTypes.CellAppearance.FocusedLayout.Font.Height := -12;
    dgLoadTypes.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgLoadTypes.CellAppearance.FocusedLayout.Font.Style := [];
    dgLoadTypes.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgLoadTypes.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgLoadTypes.CellAppearance.GroupLayout.Font.Height := -12;
    dgLoadTypes.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgLoadTypes.CellAppearance.GroupLayout.Font.Style := [];
    dgLoadTypes.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgLoadTypes.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgLoadTypes.CellAppearance.NormalLayout.Font.Height := -12;
    dgLoadTypes.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgLoadTypes.CellAppearance.NormalLayout.Font.Style := [];
    dgLoadTypes.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgLoadTypes.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgLoadTypes.CellAppearance.SelectedLayout.Font.Height := -12;
    dgLoadTypes.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgLoadTypes.CellAppearance.SelectedLayout.Font.Style := [];
    dgLoadTypes.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgLoadTypes.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgLoadTypes.CellAppearance.SummaryLayout.Font.Height := -12;
    dgLoadTypes.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgLoadTypes.CellAppearance.SummaryLayout.Font.Style := [];
    dgLoadTypes.ColumnCount := 1;
    dgLoadTypes.Columns.Clear;
    with dgLoadTypes.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Load Type';
      Name := 'LoadType';
      Width := 150.000000000000000000;
    end;
    dgLoadTypes.Designer := False;
    dgLoadTypes.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgLoadTypes.FilterAppearance.Font.Color := clWindowText;
    dgLoadTypes.FilterAppearance.Font.Height := -12;
    dgLoadTypes.FilterAppearance.Font.Name := 'Segoe UI';
    dgLoadTypes.FilterAppearance.Font.Style := [];
    dgLoadTypes.Icons.ExpandIcon.LoadFromFile('LoadTypes.WebPanel1.dgLoadTypes.Icons.ExpandIcon.svg');
    dgLoadTypes.Icons.CollapseIcon.LoadFromFile('LoadTypes.WebPanel1.dgLoadTypes.Icons.CollapseIcon.svg');
    dgLoadTypes.Icons.FilterIcon.LoadFromFile('LoadTypes.WebPanel1.dgLoadTypes.Icons.FilterIcon.svg');
    dgLoadTypes.Icons.FilterActiveIcon.LoadFromFile('LoadTypes.WebPanel1.dgLoadTypes.Icons.FilterActiveIcon.svg');
    dgLoadTypes.Icons.FilterClearIcon.LoadFromFile('LoadTypes.WebPanel1.dgLoadTypes.Icons.FilterClearIcon.svg');
    dgLoadTypes.Icons.FilterTypeIcon.LoadFromFile('LoadTypes.WebPanel1.dgLoadTypes.Icons.FilterTypeIcon.svg');
    dgLoadTypes.Icons.SortAscendingIcon.LoadFromFile('LoadTypes.WebPanel1.dgLoadTypes.Icons.SortAscendingIcon.svg');
    dgLoadTypes.Icons.SortDescendingIcon.LoadFromFile('LoadTypes.WebPanel1.dgLoadTypes.Icons.SortDescendingIcon.svg');
    dgLoadTypes.Icons.CloseIcon.LoadFromFile('LoadTypes.WebPanel1.dgLoadTypes.Icons.CloseIcon.svg');
    SetEvent(dgLoadTypes, Self, 'OnCellClick', 'dgLoadTypesCellClick');
    SetEvent(dgLoadTypes, Self, 'OnGetCellLayout', 'dgLoadTypesGetCellLayout');
    dgLoadTypes.RowCount := 1;
    dgdbaLoadTypes.SetParentComponent(dgLoadTypes);
    dgdbaLoadTypes.Name := 'dgdbaLoadTypes';
    dgdbaLoadTypes.Left := 275;
    dgdbaLoadTypes.Top := 6;
    dgdbaLoadTypes.Width := 26;
    dgdbaLoadTypes.Height := 26;
    dgdbaLoadTypes.Visible := True;
    dgdbaLoadTypes.Columns.Clear;
    with dgdbaLoadTypes.Columns.Add do
    begin
      FieldName := 'LoadType';
      Header := 'Load Type';
      AutoCreated := False;
    end;
    dgdbaLoadTypes.DataSource := dsLoadTypes;
    WebPanel4.SetParentComponent(WebPanel1);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 60;
    WebPanel4.Width := 460;
    WebPanel4.Height := 60;
    WebPanel4.Align := alTop;
    WebPanel4.ChildOrder := 1;
    WebPanel4.Color := clSilver;
    WebPanel4.TabOrder := 3;
    WebSpeedButton5.SetParentComponent(WebPanel4);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 11;
    WebSpeedButton5.Top := 11;
    WebSpeedButton5.Width := 40;
    WebSpeedButton5.Height := 40;
    WebSpeedButton5.Caption := '<<';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 0;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    WebSpeedButton6.SetParentComponent(WebPanel4);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 57;
    WebSpeedButton6.Top := 11;
    WebSpeedButton6.Width := 40;
    WebSpeedButton6.Height := 40;
    WebSpeedButton6.Caption := '<';
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.TabOrder := 1;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    WebSpeedButton7.SetParentComponent(WebPanel4);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 103;
    WebSpeedButton7.Top := 11;
    WebSpeedButton7.Width := 40;
    WebSpeedButton7.Height := 40;
    WebSpeedButton7.Caption := '>';
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.TabOrder := 2;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    WebSpeedButton8.SetParentComponent(WebPanel4);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 149;
    WebSpeedButton8.Top := 11;
    WebSpeedButton8.Width := 40;
    WebSpeedButton8.Height := 40;
    WebSpeedButton8.Caption := '>>';
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.TabOrder := 3;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    btnInsert.SetParentComponent(WebPanel4);
    btnInsert.Name := 'btnInsert';
    btnInsert.Left := 195;
    btnInsert.Top := 11;
    btnInsert.Width := 40;
    btnInsert.Height := 40;
    btnInsert.Caption := '+';
    btnInsert.Color := clNone;
    btnInsert.HeightPercent := 100.000000000000000000;
    btnInsert.TabOrder := 4;
    btnInsert.WidthPercent := 100.000000000000000000;
    SetEvent(btnInsert, Self, 'OnClick', 'btnInsertClick');
    wdsLoadTypes.SetParentComponent(Self);
    wdsLoadTypes.Name := 'wdsLoadTypes';
    wdsLoadTypes.Connection := dmData.dbConnect;
    wdsLoadTypes.Left := 136;
    wdsLoadTypes.Top := 28;
    wdsLoadTypesLoadType.SetParentComponent(wdsLoadTypes);
    wdsLoadTypesLoadType.Name := 'wdsLoadTypesLoadType';
    wdsLoadTypesLoadType.FieldName := 'LoadType';
    dsLoadTypes.SetParentComponent(Self);
    dsLoadTypes.Name := 'dsLoadTypes';
    dsLoadTypes.DataSet := wdsLoadTypes;
    dsLoadTypes.Left := 200;
    dsLoadTypes.Top := 28;
    wcLoadTypes.SetParentComponent(Self);
    wcLoadTypes.Name := 'wcLoadTypes';
    wcLoadTypes.Connection := dmData.dbConnect;
    wcLoadTypes.Left := 80;
    wcLoadTypes.Top := 28;
  finally
    WebPanel1.AfterLoadDFMValues;
    pnlHead.AfterLoadDFMValues;
    TMSFNCBitmapContainer1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    edtLoadTypesPC.AfterLoadDFMValues;
    dgLoadTypes.AfterLoadDFMValues;
    dgdbaLoadTypes.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    btnInsert.AfterLoadDFMValues;
    wdsLoadTypes.AfterLoadDFMValues;
    wdsLoadTypesLoadType.AfterLoadDFMValues;
    dsLoadTypes.AfterLoadDFMValues;
    wcLoadTypes.AfterLoadDFMValues;
  end;
end;

end.